module.exports = __webpack_public_path__ + "img/logo.e56bbb71.png";